import { getProjectIdOrKey } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_PROJECT_CONTEXT } from '../../constants.tsx';
import type { ProjectContext } from './types.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { ProjectContext, ProjectContextData } from './types';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-project-context", jiraSpaEntry: "async-resource-project-context" */ './get-data'
	);

export const projectContextResource = createResource<ProjectContext | null>({
	type: RESOURCE_TYPE_PROJECT_CONTEXT,
	getKey: (matchedRoute) => getProjectIdOrKey(matchedRoute.match, matchedRoute.query),
	getDataLoader,
	maxAge: 30 * 60 * 1000,
});

export const projectContextResourceWithCache = projectContextResource;
